import type {AgencyConfig} from 'src/types/agency';
import type {Context} from 'react';

import {createContext} from 'react';


const AgencyConfigContext: Context<Partial<AgencyConfig>> = createContext({});
export default AgencyConfigContext;
